import React, { useContext, useEffect, useMemo, useState } from "react";
import Header from "./Header";
import { KeyboardArrowRight } from "@mui/icons-material";
import { NavLink, useLocation } from "react-router-dom";
import { clearGlobalStates } from "../../../utils/UtilFunctions";
import { AppContext } from "../../../context/context";
import { empType, LicenseTypes } from "../../../utils/Enum.types";
import Customer from "../../../images/Customer.svg";
import Master from "../../../images/Masterdata.svg";
import useUrlParams from "../../../customHooks/useUrlParams";
import useLabels from "../../../customHooks/useLabels";
import { useLazyQuery } from "@apollo/client";
import {
  GetUserRightsByEmpIdResult,
  GetUserRightsByEmpIdVar,
} from "../../modules/asset/users/AssignRights/queries/types";

import useLoggedInUserDetails from "../../../customHooks/useLoggedInUserDetails";
import { TableType } from "../../modules/customer/companies/queries/types";
import useCompanyConfiguration from "../../../customHooks/useCompanyConfiguration";
import { GetUserRightsByEmpId } from "../../modules/asset/users/AssignRights/queries/queries";
import GraphView from "../../../images/GraphView.svg";
import Print from "../../../images/PrintProgressCard.svg";
import Banner from "./Banner";
interface NavProps {
  NavType: LicenseTypes;

  TeacherDashboard?: boolean;
  AdminDashboard?: boolean;
}

interface MenuItemsProps {
  menu?: string | number;
  url?: string;
  title: string;
  submenu: string[];
}

interface SubMenuProps {
  title: string;
  url: string;
}

interface SubHeaderProps {
  title: string;
  image: string;
  className: string;
  subMenu: SubMenuProps[];
}

interface MainHeaderProps {
  title: string;
  subHeader: SubHeaderProps[];
}

interface MenuItemsProps {
  mainHeader: MainHeaderProps[];
}

const Navbar = ({ NavType }: NavProps) => {
  const { state, dispatch } = useContext(AppContext);
  const { pathname } = useLocation();
  const [isOpen, setIsOpen] = useState(false);

  const [items, setItems] = useState<any>([]);

  const { user_details } = useLoggedInUserDetails();

  const { customer_id, company_id, sub_id, siteID, junctionID } =
    useUrlParams();

  const {
    USE_ENABLE_JUNCTION,
    USE_ENABLE_SUBSIDIARY,
    USE_ENABLE_SUBSIDIARY_SITE,

    USE_ENABLE_MAP,
  } = useCompanyConfiguration();
  const {
    subsidiaryLabel,
    subsidiarySiteLabel,
    itemLabel,
    junctionLabel,
    ledgerLabel,
  } = useLabels();

  const [GetRights, { data }] = useLazyQuery<
    GetUserRightsByEmpIdResult,
    GetUserRightsByEmpIdVar
  >(GetUserRightsByEmpId);

  const show = useMemo(() => {
    if (data && state.empSubType !== empType.SYS_ADMIN) {
      switch (data.GetUserRightsByEmpId.tableLevel) {
        case TableType.COMPANY:
          return window.location.pathname.split("/")[
            window.location.pathname.split("/").length - 1
          ] === "company"
            ? false
            : true;
        case TableType.SUBSIDIARY:
          return window.location.pathname.split("/")[
            window.location.pathname.split("/").length - 1
          ] === "subsidiary"
            ? false
            : true;
        case TableType.SITE:
          return window.location.pathname.split("/")[
            window.location.pathname.split("/").length - 1
          ] === "assetsite"
            ? false
            : true;

        case TableType.JUNCTION:
          return window.location.pathname.split("/")[
            window.location.pathname.split("/").length - 1
          ] === "junctions"
            ? false
            : true;
      }
    } else return true;
  }, [data, state.empSubType]);

  const isStationUser =
    state.empSubType === empType.PC ||
    state.empSubType === empType.WPC ||
    state.empSubType === empType.ASI ||
    state.empSubType === empType.WASI ||
    state.empSubType === empType.PSI ||
    state.empSubType === empType.WPSI;

  const AdminItems = [
    {
      mainHeader: [
        {
          title: "Settings",
          subHeader: [
            {
              title: "Predefined Data",
              image: `${Customer}`,
              className: "image-white",
              subMenu: [
                {
                  title: "List",
                  url: `/`,
                },
                {
                  title: "Settings Details",
                  url: `/settingsdashbord`,
                },
              ],
            },
          ],
        },
      ],
    },
  ];

  const CompanyItems = [
    {
      mainHeader: [
        USE_ENABLE_SUBSIDIARY
          ? {
              title: subsidiaryLabel,
              subHeader: [
                {
                  title: `${subsidiaryLabel}`,
                  image: `${Customer}`,
                  className: "image-white",
                  subMenu: [
                    {
                      title: "List",
                      url: `/${customer_id}/company/${company_id}/subsidiary`,
                    },
                    // {
                    //   title:`Associate ${subsidiarySiteLabel} to Supplier` ,
                    //   url: `/${customer_id}/company/${company_id}/subsidiary/assoc`,
                    // },
                  ],
                },
              ],
            }
          : null,
        {
          title: "Master",
          subHeader: [
            {
              title: "Grouping",
              image: `${Master}`,
              className: "image-white",
              subMenu: [
                {
                  title: `Grouping`,
                  url: `/${customer_id}/company/${company_id}/masters/grouping`,
                },
                {
                  title: `Grouping ${itemLabel}`,
                  url: `/${customer_id}/company/${company_id}/masters/grouping/asset`,
                },
                {
                  title: `Assign ${itemLabel}`,
                  url: `/${customer_id}/company/${company_id}/masters/grouping/assign`,
                },
              ],
            },
          ],
        },
        {
          title: "Import",
          subHeader: [
            {
              title: "Import",
              image: `${Master}`,
              className: "image-white",
              subMenu: [
                {
                  title: `Import ${itemLabel} Details`,
                  url: `/${customer_id}/company/${company_id}/importitemdetails`,
                },
                USE_ENABLE_SUBSIDIARY
                  ? {
                      title: `Import ${subsidiaryLabel} Details`,
                      url: `/${customer_id}/company/${company_id}/importsubsidiary`,
                    }
                  : null,
                USE_ENABLE_SUBSIDIARY_SITE
                  ? {
                      title: `Import ${subsidiarySiteLabel} Details`,
                      url: `/${customer_id}/company/${company_id}/importassetsite`,
                    }
                  : null,
                {
                  title: `Import ${junctionLabel} Details`,
                  url: `/${customer_id}/company/${company_id}/importjunction`,
                },
              ],
            },
            {
              title: "Import",
              image: `${Master}`,
              className: "image-white",
              subMenu: [
                {
                  title: `Bulk Alter ${itemLabel} Details`,
                  url: `/${customer_id}/company/${company_id}/bulkalteritemdetails`,
                },
              ],
            },
          ],
        },
        {
          title: itemLabel,
          subHeader: [
            {
              title: `Stock ${itemLabel} List`,
              image: `${Master}`,
              className: "image-white",
              subMenu: [
                {
                  title: `Stock ${itemLabel} List`,
                  url: `/${customer_id}/company/${company_id}/item/list`,
                },
                // {
                //   title: "Import Item Details",
                //   url: `/${customer_id}/company/${company_id}/importItemDetails`,
                // },
              ],
            },
            {
              title: `Stock ${itemLabel} OB`,
              image: `${Master}`,
              className: "image-white",
              subMenu: [
                {
                  title: `Stock ${itemLabel} List - OB`,
                  url: `/${customer_id}/company/${company_id}/item/ob/list`,
                },
                {
                  title: `Stock ${itemLabel} List -Individual`,
                  url: `/${customer_id}/company/${company_id}/item/individual/list`,
                },
              ],
            },
          ],
        },
        {
          title: "Purchase",
          subHeader: [
            {
              title: "Menu",
              image: `${Master}`,
              className: "image-white",
              subMenu: [
                {
                  title: "Purchase order",
                  url: `/${customer_id}/company/${company_id}/purchase/purchaseorder`,
                },
                {
                  title: "Purchase Entry",
                  url: `/${customer_id}/company/${company_id}/purchase/entry`,
                },
                {
                  title: "Purchase Entry - Acceptance",
                  url: `/${customer_id}/company/${company_id}/purchase/acceptance`,
                },
              ],
            },
            {
              title: "Material",
              image: `${Master}`,
              className: "image-white",
              subMenu: [
                // {
                //   title: "Material Request",
                //   url: `/${customer_id}/company/${company_id}/purchase/material/request`,
                // },
                {
                  title: "Material Request",
                  url: `/${customer_id}/company/${company_id}/purchase/material/pending`,
                },
                {
                  title: "Request for Quotation",
                  url: `/${customer_id}/company/${company_id}/purchase/quotation`,
                },
                {
                  title: "Request for Quotation Comparision",
                  url: `/${customer_id}/company/${company_id}/purchase/mqcomparision`,
                },
              ],
            },
          ],
        },
        USE_ENABLE_MAP
          ? {
              title: "Maps",
              subHeader: [
                {
                  title: "Maps",
                  image: `${Master}`,
                  className: "image-white",
                  subMenu: [
                    // {
                    //   title: "Maps",
                    //   url: `/${customer_id}/company/${company_id}/maps`,
                    // },
                    {
                      title: "Maps",
                      url: junctionID
                        ? `/${customer_id}/company/${company_id}/subsidiary/${sub_id}/site/${siteID}/junctions/${junctionID}/ticketing`
                        : siteID
                        ? `/${customer_id}/company/${company_id}/subsidiary/${sub_id}/site/${siteID}/ticketing`
                        : sub_id
                        ? `/${customer_id}/company/${company_id}/subsidiary/${sub_id}/ticketing`
                        : `/${customer_id}/company/${company_id}/ticketing`,
                    },
                  ],
                },
              ],
            }
          : null,
        {
          title: "Reports",
          subHeader: [
            {
              title: "Reports",
              image: `${GraphView}`,
              className: "image-white",
              subMenu: [
                {
                  title: `${itemLabel} Wise`,
                  url: `/${customer_id}/company/${company_id}/reports/assetsummary/0`,
                },
                {
                  title: `${ledgerLabel} Wise`,
                  url: `/${customer_id}/company/${company_id}/reports/vendorwise/0`,
                },

                {
                  title: `${junctionLabel} Wise`,
                  url: `/${customer_id}/company/${company_id}/reports/signalwise`,
                },

                {
                  title: `Ticket Details`,
                  url: `/${customer_id}/company/${company_id}/reports/ticketwise`,
                },
              ],
            },
          ],
        },
        {
          title: "Print",
          subHeader: [
            {
              title: `Print `,
              image: `${Print}`,
              className: "image-white",
              subMenu: [
                {
                  title: `${junctionLabel} details`,
                  url: `/${customer_id}/company/${company_id}/junctions`,
                },
              ],
            },
          ],
        },
      ],
    },
  ];
  const CustomerUserItems = [
    {
      mainHeader: [
        {
          title: "Main Menu",
          subHeader: [
            {
              title: "Predefined Data",
              image: `${Customer}`,
              className: "image-white",
              subMenu: [
                {
                  title: "Financial Year",
                  url: `/${customer_id}/financialYear`,
                },
                {
                  title: "Sql Number",
                  url: `/${customer_id}/customerBillBook`,
                },
              ],
            },
          ],
        },
      ],
    },
  ];
  const AssetItems = [
    {
      mainHeader: [
        {
          title: itemLabel,
          subHeader: [
            {
              title: `${itemLabel} List`,
              image: `${Master}`,
              className: "image-white",
              subMenu: [
                {
                  title: `${itemLabel} List`,
                  url: `/assets/item/${customer_id}/list`,
                },
              ],
            },
            {
              title: `${itemLabel} OB`,
              image: `${Master}`,
              className: "image-white",
              subMenu: [
                {
                  title: `${itemLabel} - OB`,
                  url: `/assets/item/${customer_id}/ob/list`,
                },
                {
                  title: `${itemLabel} - Individual`,
                  url: `/assets/item/${customer_id}/individual/list`,
                },
                {
                  title: "Stock Entry Without Purchase Entry",
                  url: `/assets/purchase/${customer_id}/stockentry/withoutpurchaseentry`,
                },
                {
                  title: "Stock Balance",
                  url: `/assets/purchase/${customer_id}/stockbalance/list`,
                },
              ],
            },
          ],
        },

        {
          title: "Purchase",
          subHeader: [
            {
              title: "Menu",
              image: `${Master}`,
              className: "image-white",
              subMenu: [
                {
                  title: "Purchase order",
                  url: `/assets/purchase/${customer_id}/purchaseorder`,
                },
                {
                  title: "Purchase Entry",
                  url: `/assets/purchase/${customer_id}`,
                },
                {
                  title: "Purchase Entry - Acceptance",
                  url: `/assets/purchase/${customer_id}/acceptance`,
                },
              ],
            },
            {
              title: "Material",
              image: `${Master}`,
              className: "image-white",
              subMenu: [
                // {
                //   title: "Material Request",
                //   url: `/assets/purchase/${customer_id}/material/request`,
                // },
                {
                  title: "Material Request",
                  url: `/assets/purchase/${customer_id}/material/pending`,
                },
                {
                  title: "Request for Quotation",
                  url: `/assets/purchase/${customer_id}/quotation`,
                },
                {
                  title: "Request for Quotation Comparision",
                  url: `/assets/purchase/${customer_id}/mqcomparision`,
                },
              ],
            },
          ],
        },
      ],
    },
  ];

  const SubsidiaryItems = [
    {
      mainHeader: [
        // {
        //   title: "Material",
        //   subHeader: [
        //     {
        //       title: "Material",
        //       image: `${Master}`,
        //       className: "image-white",
        //       subMenu: [
        //         {
        //           title: "Material Request",
        //           url: `/${customer_id}/company/${company_id}/subsidiary/${sub_id}/material/request`,
        //         },
        //       ],
        //     },
        //   ],
        // },

        // {
        //   title: itemLabel,
        //   subHeader: [
        //     {
        //       title: `${itemLabel} List`,
        //       image: `${Master}`,
        //       className: "image-white",
        //       subMenu: [
        //         {
        //           title: `${itemLabel} List`,
        //           url: `/${customer_id}/company/${company_id}/subsidiary/${sub_id}/item/list`,
        //         },
        //       ],
        //     },
        //     {
        //       title: `${itemLabel} OB`,
        //       image: `${Master}`,
        //       className: "image-white",
        //       subMenu: [
        //         {
        //           title: `${itemLabel} - OB`,
        //           url: `/${customer_id}/company/${company_id}/subsidiary/${sub_id}/item/ob/list`,
        //         },
        //         {
        //           title: `${itemLabel} - Individual`,
        //           url: `/${customer_id}/company/${company_id}/subsidiary/${sub_id}/item/individual/list`,
        //         },
        //       ],
        //     },
        //   ],
        // },
        // {
        //   title: "Import",
        //   subHeader: [
        //     {
        //       title: "Import",
        //       image: `${Master}`,
        //       className: "image-white",
        //       subMenu: [
        //         {
        //           title: "Import Item Details",
        //           url: `/${customer_id}/company/${company_id}/subsidiary/${sub_id}/importitemdetails`,
        //         },
        //       ],
        //     },
        //   ],
        // },
        {
          title: "Maps",
          subHeader: [
            {
              title: "Maps",
              image: `${Master}`,
              className: "image-white",
              subMenu: [
                {
                  title: "Maps",
                  url: `/${customer_id}/company/${company_id}/subsidiary/${sub_id}/ticketing`,
                },
              ],
            },
          ],
        },
      ],
    },
  ];

  const CustomerUsersMenu = [
    {
      mainHeader: [
        {
          title: "Master",
          subHeader: [
            {
              title: "Masters",
              image: `${Master}`,
              className: "image-white",
              subMenu: [
                {
                  title: `Stock ${itemLabel} Group`,
                  url: `/${customer_id}/company/masters/itemgroup`,
                },
                {
                  title: "Category",
                  url: `/${customer_id}/company/masters/category`,
                },
                {
                  title: "Ticket Reason",
                  url: `/${customer_id}/company/masters/ticketReason`,
                },
                {
                  title: "Device Type",
                  url: `/${customer_id}/company/masters/deviceType`,
                },
                {
                  title: "Manufacturer",
                  url: `/${customer_id}/company/masters/manufacturer`,
                },              
                {
                  title: "UOM",
                  url: `/${customer_id}/company/masters/unitofmeasurement`,
                },
                {
                  title: `Stock ${itemLabel}`,
                  url: `/${customer_id}/company/masters/items`,
                },
                {
                  title: `Stock ${itemLabel} Error Messages`,
                  url: `/${customer_id}/company/masters/itemserrormessage`,
                },
                {
                  title: ledgerLabel,
                  url: `/${customer_id}/company/masters/supplier`,
                },
                {
                  title: "Project Details",
                  url: `/${customer_id}/company/masters/projectDetails`,
                },
              ],
            },
            {
              title: "Association",
              image: `${Master}`,
              className: "image-white",
              subMenu: [
                {
                  title: `Associate ${ledgerLabel} to ${itemLabel}`,
                  url: `/${customer_id}/company/masters/assoc`,
                },
                {
                  title: `Associate ${itemLabel} to ${ledgerLabel}`,
                  url: `/${customer_id}/company/masters/assoc/itemstovendor`,
                },
                {
                  title: `Associate Employees to ${ledgerLabel}`,
                  url: `/${customer_id}/company/masters/assoc/employeestovendor`,
                },
              ],
            },
          ],
        },
        {
          title: "Users",
          subHeader: [
            {
              title: "User Rights",
              image: `${Master}`,
              className: "image-white",
              subMenu: [
                {
                  title: "Create a login Users",
                  url: `/${customer_id}/company/users`,
                },
                {
                  title: "Users Rights Assigned List",
                  url: `/${customer_id}/company/users/assignedlist`,
                },
                {
                  title: "Reset User Password",
                  url: `/${customer_id}/company/users/resetuserpassword`,
                },
                {
                  title: "Enable User Login",
                  url: `/${customer_id}/company/users/enableuserlogin`,
                },
                {
                  title: "User Device Details",
                  url: `/${customer_id}/company/users/devicelist`,
                },
              ],
            },
          ],
        },
        {
          title: "Reports",
          subHeader: [
            {
              title: "Reports",
              image: `${GraphView}`,
              className: "image-white",
              subMenu: [
                {
                  title: `${itemLabel} Summary`,
                  url: `/${customer_id}/reports/`,
                },
              ],
            },
          ],
        },
      ],
    },
  ];

  const SettingsMenu = [
    {
      mainHeader: [
        {
          title: "Configurations",
          subHeader: [
            {
              title: "Configurations",
              image: `${Master}`,
              className: "image-white",
              subMenu: [
                {
                  title: "Configurations",
                  url: `/${customer_id}/configurations`,
                },
                {
                  title: "Email Configurations",
                  url: `/${customer_id}/emailconfig`,
                },
                {
                  title: "Bill Book Configuration",
                  url: `/${customer_id}/billbook`,
                },
              ],
            },
          ],
        },
      ],
    },
  ];
  const DashboardMenu = [
    {
      mainHeader: [
        state.empSubType !== empType.HELP_DESK
          ? {
              title: "Projects",
              subHeader: [
                {
                  title: "Project Details",
                  image: `${Master}`,
                  className: "image-white",
                  subMenu: [
                    {
                      title: "Projects Details",
                      url: `/${customer_id}/projectdetails`,
                    },
                    {
                      title: "Work Progress",
                      url: `/${customer_id}/workprogress`,
                    },
                    state.empSubType === empType.PMU ||
                    state.empSubType === empType.JCP ||
                    state.empSubType === empType.ACP
                      ? {
                          title: "PMU-Traffic Engineering Studies",
                          url: `/${customer_id}/casestudy`,
                        }
                      : null,
                  ],
                },
                state.empSubType === empType.PMU
                  ? {
                      title: "Master",
                      image: `${Master}`,
                      className: "image-white",
                      subMenu: [
                        {
                          title: "Add Table Format",
                          url: `/${customer_id}/projectheaders/`,
                        },
                        {
                          title: "Add Junctions",
                          url: `/${customer_id}/junctions`,
                        },
                        {
                          title: `Add ${itemLabel} Details`,
                          url: `/${customer_id}/assetsummary/0`,
                        },
                      ],
                    }
                  : null,
              ].filter(Boolean),
            }
          : null,

        {
          title: "Reports",
          subHeader: [
            {
              title: "Reports",
              image: `${GraphView}`,
              className: "image-white",
              subMenu: [
                {
                  title: `${itemLabel} Wise`,
                  url: `/${customer_id}/reports/assetsummary/0`,
                },
                {
                  title: `${ledgerLabel} Wise`,
                  url: `/${customer_id}/reports/vendorwise/0`,
                },
                {
                  title: `${junctionLabel} Wise`,
                  url: `/${customer_id}/reports/signalwise/0`,
                },
                {
                  title: `Ticket Details`,
                  url: `/${customer_id}/reports/ticketwise`,
                },
              ],
            },
          ],
        },
        isStationUser
          ? {
              title: "Calibration",
              subHeader: [
                {
                  title: "Calibration",
                  image: `${GraphView}`,
                  className: "image-white",
                  subMenu: [
                    {
                      title: `Calibration`,
                      url: `/${customer_id}/calibration`,
                    },
                  ],
                },
              ],
            }
          : null,
      ].filter(Boolean),
    },
  ];

  useEffect(() => {
    if (show)
      if (NavType === LicenseTypes.ADMIN) {
        setItems(AdminItems);
      } else if (NavType === LicenseTypes.ASSET) {
        setItems(AssetItems);
      } else if (NavType === LicenseTypes.CUSTOMER) {
        setItems(CustomerUserItems);
      } else if (NavType === LicenseTypes.COMPANY) {
        setItems(CompanyItems);
      } else if (NavType === LicenseTypes.SUBSIDIARY) {
        setItems(SubsidiaryItems);
      } else if (NavType === LicenseTypes.CUSTOMER_USERS) {
        setItems(CustomerUsersMenu);
      } else if (NavType === LicenseTypes.CONFIG) {
        setItems(SettingsMenu);
      } else if (
        NavType === LicenseTypes.DASHBOARD &&
        (state.empSubType === empType.JCP ||
          state.empSubType === empType.PMU ||
          state.empSubType === empType.VENDOR_MANAGER ||
          state.empSubType === empType.HELP_DESK ||
          isStationUser)
      ) {
        setItems(DashboardMenu);
      } else {
        setItems([]);
      }
    else setItems([]);
    // eslint-disable-next-line
  }, [
    NavType,
    subsidiaryLabel,
    show,
    itemLabel,
    ledgerLabel,
    subsidiarySiteLabel,
    USE_ENABLE_JUNCTION,
    USE_ENABLE_SUBSIDIARY,
    USE_ENABLE_SUBSIDIARY_SITE,
    USE_ENABLE_MAP,
    state.empSubType,
  ]);

  useEffect(() => {
    const fetchData = async () => {
      if (customer_id) {
        GetRights({
          variables: {
            customerID: customer_id,
            empID: user_details.id,
          },
        });
      }
    };
    fetchData();
  }, [GetRights, user_details.id, customer_id]);

  return (
    <>
      <div className="row g-0">
        <Header />
      </div>
      <div className="row g-0">
        <Banner />
      </div>

      <div className="menus">
        <ul>
          {items.map((menuItem: MenuItemsProps, menuIndex: React.Key) =>
            menuItem.mainHeader.map((mainItem, mainIndex) => {
              const isMainActive = mainItem?.subHeader?.some((subItem) =>
                subItem?.subMenu?.some((linkItem) => linkItem?.url === pathname)
              );
              return (
                <li
                  className={`menus__dropdown ${isMainActive ? "active" : ""}`}
                  key={`${menuIndex}-${mainIndex}`}
                >
                  <button
                    className={mainItem?.title ? "dropbtn" : ""}
                    aria-haspopup="true"
                    onClick={() => setIsOpen(!isOpen)}
                  >
                    {mainItem?.title}
                    {mainItem?.title ? <KeyboardArrowRight /> : null}
                  </button>
                  {isOpen && (
                    <div className="menus__dropdown-content">
                      <div className="menus__dropdown-content--flex">
                        {Array.isArray(mainItem?.subHeader) &&
                          mainItem?.subHeader.map((subItem, subIndex) => (
                            <div key={`${menuIndex}-${mainIndex}-${subIndex}`}>
                              <React.Fragment>
                                <div className="menus__dropdown-content--title">
                                  <div className="menus__dropdown-content--image">
                                    <img
                                      src={subItem?.image}
                                      alt=""
                                      className={subItem?.className}
                                    />
                                  </div>
                                  <div>
                                    <h6>{subItem?.title}</h6>
                                    <hr />
                                  </div>
                                </div>
                                <div
                                  className={
                                    subItem?.title.length > 1
                                      ? "border-right"
                                      : ""
                                  }
                                >
                                  {subItem?.subMenu?.map(
                                    (linkItem, linkIndex) => (
                                      <NavLink
                                        to={linkItem?.url}
                                        onClick={() => {
                                          clearGlobalStates(dispatch, state);
                                        }}
                                        key={`${menuIndex}-${mainIndex}-${subIndex}-${linkIndex}`}
                                        className={({ isActive }) =>
                                          `${
                                            linkItem?.title
                                              ? "menus__dropdown-content--routes"
                                              : ""
                                          } ${isActive ? "active" : ""}`
                                        }
                                      >
                                        {linkItem?.title}
                                      </NavLink>
                                    )
                                  )}
                                </div>
                              </React.Fragment>
                            </div>
                          ))}
                      </div>
                    </div>
                  )}
                </li>
              );
            })
          )}
        </ul>
      </div>
    </>
  );
};

export default Navbar;
